import { lazy } from "react"
import type { CustomRoute } from "@/shared/types"

const CompanyEnergyAuditHistory = lazy(async () => await import("@/pages/dashboard/company-energy-audit/history/index.ts"))

export const companyEnergyAuditHistoryRoutes: CustomRoute = {
  path: "history",
  handle: { label: "История", i18Key: "energy-audit__history" },
  Component: CompanyEnergyAuditHistory
}
